<template>
    <div class="product-detail">
      <!-- <h2 >{{rtitle}}-客评</h2> -->
      <TitleModel
            :title="rtitle+'-反馈'"
            content="我们保证" 
            content2="所有客户反馈及验证皆属真实 欢迎预约品鉴"
            content3=" "/> 
      
      <div class="wp-relative">   
        <el-row :gutter="20" class="product-grid">
          
          <el-col v-if="urls.length == 0" class="NoReviewCss" >
            暂没有评价，敬请期待！
          </el-col>

          <el-col 
            :xs="24"  
            :sm="12" 
            :md="8" 
            :lg="6" 
            :xl="6"
            v-for="url in urls" 
            :key="url"
            class="product-col"
          >
            <!-- <el-card class="product-card" hover> -->
              <div class="product-image">
                <!-- <img :src="url" :alt="url" class="product-img">  -->
                <el-image
                  style="width: 100%; max-height: 85vh"
                  :src="url"
                  :zoom-rate="1"
                  :max-scale="7"
                  :min-scale="0.2"  
                  fit="contain"
                />
              </div> 
            <!-- </el-card> -->
          </el-col>
        </el-row>
 
      </div> 
     
    </div>
  </template>
  
<script>
import { ref, onMounted } from 'vue'; 
import { useRoute } from 'vue-router'; // 导入useRoute钩子 
import { Navigation,Autoplay,Pagination  } from 'swiper'; 
import { get } from '@/api/AxiosUtils';

import 'swiper/css';
import 'swiper/css/navigation'; 
import 'swiper/css/pagination'; 
import 'swiper/css/autoplay';
import { useStore } from 'vuex';
import TitleModel from '@/components/TitleModel.vue';

export default {
props: {
    images:{
        type:Array,
        default:() => []
    }
},
components: {
    // Swiper,
    // SwiperSlide 
    TitleModel
},

setup() {
  const route = useRoute();
  const store = useStore();
 
//   const urls = [
//   // 'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
//   // 'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg',
//   // 'https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg',
//   // 'https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg',
//   // 'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg',
//   // 'https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg',
//   // 'https://fuss10.elemecdn.com/2/11/6535bcfb26e4c79b48ddde44f4b6fjpeg.jpeg',
// ]
 

  const getReview = async (id) => {
    try {
      const url = '/api/index/getPrincessReviews';
      const response  =  await get(url,{id:id},{}); 

      let _strs = response.data.review_images;
      if(_strs){
        let  _arr = _strs.split(',');
        urls.value = [];
        for(let i=0;i<_arr.length;i++){
          urls.value.push(store.state.apiImgUrl+_arr[i]);
        }
      }
      // console.log('---res1232 ',urls)
    } catch (error) {
      console.error('Network Error:', error);
      // 添加一些默认图片作为备用
      urls.value = [];
    }
  }
  const rid = route.params.pid;
  const rtitle = route.query.title;
  const urls = ref([]);
   
  onMounted(()=>{
     
    if (rid) {
      getReview(rid);
    } else {
      console.warn('未获取到有效的ID参数');
    }
  })
  
  return {   
    urls, 
    rtitle,
    getReview,
    modules: {Navigation, Autoplay,Pagination} 
  };
}
};
</script>
    
<style lang="scss" scoped>
@import url(@/assets/css/commPage.scss);~
  
.product-detail {
  // max-width: 800px;
  margin: 0 auto; 
  width: 100%;
  max-width: 1200px; 
  padding: 0 20px;
} 

.product-col,.product-grid{margin-top: 0.5rem;}
 
.NoReviewCss{
  font-size: 24px;
  font-weight: 1000;
  background: -webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
}
 
</style>

